module.exports = __webpack_public_path__ + "img/mentor8.dde0e4a.jpg";